import { Button, DatePicker, Form, Modal, Row, notification } from 'antd'
import moment from 'moment'
import { WarningFilled } from '@ant-design/icons'

const { RangePicker } = DatePicker

import './ModalProductionStatus.style.less'

import { createProductionStatus } from '../../Production.service'
import { getUrlParams } from '@/utils/common'
import { useState } from 'react'
import { toString } from 'lodash'

interface Props {
  visible: boolean
  orderQuantity: string
  toBeDeliveredDate: Date
  onClose: () => void
  onSetPlan: (dateData: any) => void
}

function CreateModal(props: Props) {
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = useState(false)

  const { visible, onClose, orderQuantity = '', toBeDeliveredDate = '' } = props

  const onSave = async (data) => {
    setIsLoading(true)
    const orderKey = getUrlParams('orderKey')
    const result = await createProductionStatus(orderKey, data.planned_dates)
    setIsLoading(true)
    if (String(result?.data?.statusCode).includes('20')) {
      props.onSetPlan(result?.data?.data)
      setIsLoading(false)
    } else {
      setIsLoading(false)
      notification.error({
        message: result,
        duration: 3,
        placement: 'top',
      })
    }
  }

  const valueOrders = toString(orderQuantity).replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ','
  )
  const deliveryDate = moment(toBeDeliveredDate).format('DD MMM YYYY')

  return (
    <Modal
      className="modal-container"
      open={visible}
      onCancel={onClose}
      centered
      footer={false}
      maskClosable={false}
    >
      <h1>Production Status</h1>
      <p>Set your production dates to generate the plan.</p>
      <Row className="content-container">
        <Form className="form-container" onFinish={onSave} form={form}>
          <Form.Item
            className="form-item"
            label="Planned Dates"
            labelCol={{ span: 10 }}
            name="planned_dates"
            rules={[
              {
                required: true,
                message: 'This field is required',
              },
            ]}
          >
            <RangePicker size="large" />
          </Form.Item>
          <p>
            <WarningFilled className="icon" />
            Order quantity is <span>{valueOrders} pieces</span> - Delivery is
            planned on <span>{deliveryDate}</span>
          </p>
          <Form.Item>
            <Row className="content-container">
              <Button
                className="create-btn"
                key="upsert"
                size="large"
                onClick={() => onClose()}
              >
                Cancel
              </Button>
              <Button
                className="cancel-btn"
                key="upsert"
                type="primary"
                size="large"
                htmlType="submit"
                loading={isLoading}
              >
                Create
              </Button>
            </Row>
          </Form.Item>
        </Form>
      </Row>
    </Modal>
  )
}

export default CreateModal
